/* eslint-disable no-unused-vars */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Divider,
} from '@material-ui/core';
import { Nav, Tab, Dropdown } from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SVG from 'react-inlinesvg';
import axios from 'axios';
import moment from 'moment';
import { Close } from '@material-ui/icons';
import { CircularProgress, IconButton } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { Badge } from '@material-ui/core';
import { shallowEqual, useSelector } from 'react-redux';
import objectPath from 'object-path';
import { useHtmlClassService } from '../../../_core/MetronicLayout';
import { toAbsoluteUrl } from '../../../../_helpers';
import { DropdownTopbarItemToggler } from '../../../../_partials/dropdowns';
import { useWebsocket } from '../../../../../app/contexts/WebsocketContext';
import { notificationsConfig } from '../../../../../app/utils/notificationsConfig';

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
};

const msgIcon = {
  'processing-group-creation': '/media/svg/senseworks/processing-groups.svg',
  'processing-group-deployment': '/media/svg/senseworks/setting-gateway.svg',
  'tags-creation': '/media/svg/senseworks/wifi-signal-4.svg',
};

const msgOpts = [
  'processing-group-creation',
  'processing-group-deployment',
  'account-creation',
  'account-deletion',
  'tags-creation',
];

function UserNotificationsDropdown({ intl }) {
  const [key, setKey] = useState('events');
  const [tagNotifications, setTagNotifications] = useState([]);
  const [events, setEvents] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [notificationsCounter, setNotificationsCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const loggedUser = useSelector(({ auth }) => auth.user, shallowEqual);
  const alertsKey = intl.formatMessage({ id: 'ALERTS' });
  const eventsKey = intl.formatMessage({ id: 'EVENTS' });
  const { message, websocket, isReady } = useWebsocket();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const msgLabel = notificationsConfig(intl, history);

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      offcanvas:
        objectPath.get(uiService.config, 'extras.notifications.layout') ===
        'offcanvas',
    };
  }, [uiService]);

  useEffect(() => {
    getPendingNotifications(true);
  }, []);

  useEffect(() => {
    if (message && msgOpts.includes(message.event)) {
      if (!message.event.startsWith('account')) {
        setNotificationsCounter(val => (val += 1));
      }
      if (message.event === 'tags-creation' && message.data.type === 'alert') {
        const lines = message.data.error.split('lines')[1];
        setTagNotifications(lines.split(','));
      }
      const configs = msgLabel(message);
      enqueueSnackbar(configs.snackbarMessage, {
        variant: configs.snackbarColor,
        autoHideDuration: 5000,
        className: 'cursor-pointer',
        onClick: configs.onClick,
      });
    }
  }, [message]);

  useEffect(() => {
    if (isReady) {
      websocket.send(
        JSON.stringify({
          event: 'processing-group-deployment',
          type: 'subscribe',
          data: {
            businessEntityId: loggedUser.entityId,
            businessUserId: loggedUser.userId,
          },
        })
      );
      if (loggedUser.isSuperAdmin) {
        websocket.send(
          JSON.stringify({
            event: 'account-creation',
            type: 'subscribe',
            data: {
              businessUserId: loggedUser.userId,
              businessEntityId: loggedUser.entityId,
            },
          })
        );
        websocket.send(
          JSON.stringify({
            event: 'account-deletion',
            type: 'subscribe',
            data: {
              businessUserId: loggedUser.userId,
              businessEntityId: loggedUser.entityId,
            },
          })
        );
        websocket.send(
          JSON.stringify({
            event: 'tags-creation',
            type: 'subscribe',
            data: {
              businessUserId: loggedUser.userId,
            },
          })
        );
      }
    }
  }, [isReady]);

  async function getPendingNotifications(isOpen) {
    if (isOpen) {
      try {
        setIsLoading(true);
        const { data } = await axios.get(
          `/notifications?businessUserId=${loggedUser.userId}`
        );
        const eventMessages = data
          .filter(x => x.message.data?.type === 'event')
          .map(x => ({
            ...x.message,
            id: x.id,
          }));
        const alertMessages = data
          .filter(x => x.message.data?.type === 'alert')
          .map(x => ({
            ...x.message,
            id: x.id,
          }));
        setAlerts(alertMessages);
        setEvents(eventMessages);
        setNotificationsCounter(eventMessages.length + alertMessages.length);
        if (!alertMessages.length && eventMessages.length) setKey('events');
        else setKey('alerts');
      } finally {
        setIsLoading(false);
      }
    }
  }

  const toggleAlert = (val, evt) => {
    setDropdownOpen(val);
    getPendingNotifications(val);
    if (evt) evt.stopPropagation();
  };

  function removeNotification(id, type) {
    return async () => {
      if (type === 'event') setEvents(val => val.filter(x => x.id !== id));
      else setAlerts(val => val.filter(x => x.id !== id));
      setNotificationsCounter(val => (val -= 1));
      axios.put(`/notifications/${id}`);
    };
  }

  function markAsRead(type) {
    return () => {
      if (type === 'event') {
        setEvents([]);
        setNotificationsCounter(val => (val -= events.length));
        events.map(x => axios.put(`/notifications/${x.id}`));
      } else {
        setAlerts([]);
        setNotificationsCounter(val => (val -= alerts.length));
        alerts.map(x => axios.put(`/notifications/${x.id}`));
      }
    };
  }

  const closeModal = () => {
    setTagNotifications([]);
  };

  return (
    <>
      {layoutProps.offcanvas && (
        <div className="topbar-item">
          <div
            className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-primary"
            id="kt_quick_notifications_toggle"
          >
            <span className="svg-icon svg-icon-xl svg-icon-primary">
              <SVG
                src={toAbsoluteUrl('/media/svg/senseworks/alarm-bell-ring.svg')}
              />
            </span>
            <span className="pulse-ring"></span>
          </div>
        </div>
      )}
      {!layoutProps.offcanvas && (
        <Dropdown drop="down" onToggle={toggleAlert} show={isDropdownOpen}>
          <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="kt_quick_notifications_toggle"
          >
            <>
              {notificationsCounter ? (
                <Badge badgeContent={notificationsCounter} color="error">
                  <div
                    className="btn btn-icon btn-clean btn-lg mr-1 pulse pulse-warning"
                    id="kt_quick_notifications_toggle"
                  >
                    <span className="svg-icon svg-icon-xl svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/alarm-bell-ring.svg'
                        )}
                      />
                    </span>
                    <span className="pulse-ring"></span>
                    <span className="pulse-ring" />
                  </div>
                </Badge>
              ) : (
                <div
                  className="btn btn-icon btn-clean btn-lg mr-1"
                  id="kt_quick_notifications_toggle"
                >
                  <span className="svg-icon svg-icon-xl svg-icon-primary">
                    <SVG
                      src={toAbsoluteUrl(
                        '/media/svg/senseworks/alarm-bell-ring.svg'
                      )}
                    />
                  </span>
                </div>
              )}
            </>
          </Dropdown.Toggle>

          <Dropdown.Menu className="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg">
            <div className="d-flex flex-column attention-bg rounded-top">
              <h5 className="d-flex align-items-center px-4 pt-3 rounded-top mb-0 pb-0">
                <span
                  className="font-weight-bolder"
                  style={{ color: ' #000000' }}
                >
                  {intl.formatMessage({ id: 'NOTIFICATIONS' })}
                </span>
              </h5>
              <Tab.Container activeKey={key}>
                <Nav
                  as="ul"
                  className="nav nav-bold nav-tabs nav-tabs-line nav-tabs-line-2x nav-tabs-line-transparent-white nav-tabs-line-active-border-notifications mt-3 px-4"
                  onSelect={_key => setKey(_key)}
                >
                  <Nav.Item as="li">
                    <Nav.Link
                      eventKey={'alerts'}
                      style={{ color: 'black' }}
                      className={`nav-link show pt-0 w-75px d-flex justify-content-center mr-0 ${
                        key === 'alerts' ? 'active' : ''
                      }`}
                    >
                      <SVG
                        src={toAbsoluteUrl(
                          '/media/svg/senseworks/alert-black.svg'
                        )}
                        width={20}
                        height={20}
                        className="mr-2"
                      />
                      {alertsKey}
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item as="li">
                    <Nav.Link
                      eventKey={'events'}
                      style={{ color: 'black' }}
                      className={`nav-link show pt-0 w-75px d-flex justify-content-center ${
                        key === 'events' ? 'active' : ''
                      }`}
                    >
                      <SVG
                        src={toAbsoluteUrl('/media/svg/senseworks/bubble.svg')}
                        width={20}
                        height={20}
                        className="mr-2"
                      />
                      {eventsKey}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content className="tab-content">
                  <Tab.Pane eventKey={'alerts'} className="p-4">
                    <PerfectScrollbar
                      options={perfectScrollbarOptions}
                      className="scroll pr-7 mr-n7"
                      style={{ height: 300, position: 'relative' }}
                    >
                      {isLoading ? (
                        <div className="d-flex flex-center h-100">
                          <CircularProgress color="secondary" />
                        </div>
                      ) : (
                        <div className="d-flex flex-column">
                          {alerts.length > 0 && (
                            <div className="d-flex justify-content-end mb-3">
                              <span
                                className="btn-hiperlink"
                                onClick={markAsRead('alert')}
                              >
                                {intl.formatMessage({ id: 'READ_ALL' })}
                              </span>
                            </div>
                          )}
                          {alerts.map((msg, index) => (
                            <div
                              className="d-flex flex-center mb-3"
                              key={index}
                            >
                              <div className="symbol symbol-40 symbol-light-primary">
                                <span className="symbol-label">
                                  <SVG
                                    cacheRequests={true}
                                    src={toAbsoluteUrl(msgIcon[msg.event])}
                                    width={30}
                                    height={30}
                                  />
                                </span>
                              </div>
                              <div className="d-flex flex-column ml-3">
                                <span>{msgLabel(msg).label}</span>
                                <span className="text-muted">
                                  {moment(msg.data.timestamp).fromNow()}
                                </span>
                              </div>
                              <IconButton
                                className="p-2"
                                onClick={removeNotification(
                                  msg.id,
                                  msg.data?.type
                                )}
                              >
                                <Close />
                              </IconButton>
                            </div>
                          ))}
                        </div>
                      )}
                    </PerfectScrollbar>
                  </Tab.Pane>
                  <Tab.Pane eventKey={'events'} className="p-4">
                    <PerfectScrollbar
                      options={perfectScrollbarOptions}
                      className="scroll pr-7 mr-n7"
                      style={{ height: 300, position: 'relative' }}
                    >
                      {isLoading ? (
                        <div className="d-flex flex-center h-100">
                          <CircularProgress color="secondary" />
                        </div>
                      ) : (
                        <div className="d-flex flex-column">
                          {events.length > 0 && (
                            <div className="d-flex justify-content-end mb-3">
                              <span
                                className="btn-hiperlink"
                                onClick={markAsRead('event')}
                              >
                                {intl.formatMessage({ id: 'READ_ALL' })}
                              </span>
                            </div>
                          )}
                          {events.map((msg, index) => (
                            <div
                              className="d-flex flex-center mb-5 position-relative"
                              key={index}
                            >
                              <div className="symbol symbol-40 symbol-light-primary">
                                <span className="symbol-label">
                                  <SVG
                                    cacheRequests={true}
                                    src={toAbsoluteUrl(msgIcon[msg.event])}
                                    width={30}
                                    height={30}
                                  />
                                </span>
                              </div>
                              <div className="d-flex flex-column ml-3">
                                <span>{msgLabel(msg).label}</span>
                                <span className="text-muted">
                                  {moment(msg.data.timestamp).fromNow()}
                                </span>
                              </div>
                              <IconButton
                                className="p-2"
                                onClick={removeNotification(
                                  msg.id,
                                  msg.data?.type
                                )}
                              >
                                <Close />
                              </IconButton>
                            </div>
                          ))}
                        </div>
                      )}
                    </PerfectScrollbar>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      )}
      <Dialog fullWidth open={!!tagNotifications.length}>
        <DialogTitle>
          <div className="col-12">Oops!</div>
        </DialogTitle>
        <Divider />
        <DialogContent style={{ minHeight: 80, maxHeight: 240 }}>
          <div className="d-flex">
            <div className="col-2">
              <SVG src={toAbsoluteUrl('/media/senseworks/alert.svg')} />
            </div>
            <div className="col-10 d-flex flex-column">
              <span className="d-block mb-3">
                An error has occurred while processing your file in the
                following lines:
              </span>
              <ul className="overflow-auto" style={{ paddingLeft: 20 }}>
                {tagNotifications.map((not, index) => (
                  <li key={index}>Line {not.trim()}</li>
                ))}
              </ul>
            </div>
          </div>
        </DialogContent>
        <Divider />
        <DialogActions>
          <button
            type="button"
            onClick={closeModal}
            className="btn btn-bordered h-25px w-50px d-flex align-items-center btn-primary justify-content-center"
          >
            {intl.formatMessage({ id: 'ACTIONS.OK' })}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default injectIntl(UserNotificationsDropdown);
